/* eslint-disable */
// This code is autogenerated using @harnessio/oats-cli.
// Please do not modify this code directly.
import { fetcher, FetcherOptions } from './fetcher';

export interface UserPromptConstantOverridesGetPromptConstantsRetrieveAPIQueryParams {
  workflows: 'multimodal_clip_generation' | 'text_generation';
}

export type UserPromptConstantOverridesGetPromptConstantsRetrieveOkResponse =
  unknown;

export type UserPromptConstantOverridesGetPromptConstantsRetrieveErrorResponse =
  unknown;

export interface UserPromptConstantOverridesGetPromptConstantsRetrieveProps
  extends Omit<
    FetcherOptions<
      UserPromptConstantOverridesGetPromptConstantsRetrieveAPIQueryParams,
      unknown
    >,
    'url'
  > {
  queryParams: UserPromptConstantOverridesGetPromptConstantsRetrieveAPIQueryParams;
}

export function userPromptConstantOverridesGetPromptConstantsRetrieve(
  props: UserPromptConstantOverridesGetPromptConstantsRetrieveProps
): Promise<UserPromptConstantOverridesGetPromptConstantsRetrieveOkResponse> {
  return fetcher<
    UserPromptConstantOverridesGetPromptConstantsRetrieveOkResponse,
    UserPromptConstantOverridesGetPromptConstantsRetrieveAPIQueryParams,
    unknown
  >({
    url: `/user/prompt_constant_overrides/get_prompt_constants/`,
    method: 'GET',
    ...props
  });
}
